import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const partyTypes = [
  {
    icon: 'ri-heart-line',
    title: 'Casamentos',
    description: 'A pista fica cheia a noite toda — vários DJs em canais diferentes, cada convidado escolhe o que dançar. Os avós ouvem clássicos, os jovens ouvem eletrônico, e ninguém reclama do volume.',
    highlight: 'Festa até o amanhecer sem reclamação',
    image: '/img/stib/festa-silent-disco.webp',
  },
  {
    icon: 'ri-building-line',
    title: 'Confraternizações Corporativas',
    description: 'Transforme o evento de fim de ano da empresa em uma experiência inesquecível. Os colaboradores adoram a novidade e a interação entre canais gera conversas e conexões genuínas.',
    highlight: 'Team building com música',
    image: '/img/stib/festa-silent-disco.webp',
  },
  {
    icon: 'ri-sun-line',
    title: 'Festivais e Eventos ao Ar Livre',
    description: 'Silent Disco é o formato ideal para festivais em parques, praças e áreas urbanas. Música de alta qualidade sem poluição sonora. Perfeito para eventos diurnos e noturnos.',
    highlight: 'Zero impacto sonoro',
    image: '/img/stib/festa-silent-disco.webp',
  },
  {
    icon: 'ri-cake-line',
    title: 'Aniversários e Formaturas',
    description: 'De aniversários de 15 anos a formaturas universitárias, a Silent Disco cria uma experiência única. O LED dos fones vira parte da decoração e das fotos.',
    highlight: 'Experiência instagramável',
    image: '/img/stib/festa-silent-disco.webp',
  },
  {
    icon: 'ri-hotel-line',
    title: 'Eventos em Hotéis e Resorts',
    description: 'Ideal para resorts e hotéis que precisam de entretenimento noturno sem incomodar hóspedes. A festa acontece na beira da piscina enquanto outros hóspedes dormem tranquilamente.',
    highlight: 'Entretenimento sem incomodar hóspedes',
    image: '/img/stib/festa-silent-disco.webp',
  },
  {
    icon: 'ri-calendar-event-line',
    title: 'Eventos Temáticos',
    description: 'Festas temáticas ganham vida com Silent Disco. Anos 80, Luau, Neon Party — cada canal pode tocar um gênero diferente e os LEDs complementam a decoração.',
    highlight: 'Total liberdade criativa',
    image: '/img/stib/festa-silent-disco.webp',
  },
];

export default function PartyTypesSection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section ref={ref} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-4 block">
            Ocasões
          </span>
          <h2
            className={`font-heading font-bold text-5xl md:text-6xl text-secondary mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            para qual festa
          </h2>
          <p
            className={`font-body text-xl text-gray-500 max-w-2xl mx-auto transition-all duration-700 delay-150 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            Silent Disco se adapta a qualquer tipo de celebração — do casamento mais elegante ao festival mais descolado
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {partyTypes.map((party, i) => (
            <article
              key={i}
              className={`group bg-white border border-gray-100 rounded-3xl overflow-hidden hover:border-primary/30 hover:-translate-y-1 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={party.image}
                  alt={`Festa silenciosa em ${party.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary/10">
                    <i className={`${party.icon} text-primary text-xl`} />
                  </div>
                  <h3 className="font-heading font-bold text-xl text-secondary">{party.title}</h3>
                </div>
                <p className="font-body text-sm text-gray-600 leading-relaxed mb-4">{party.description}</p>
                <div className="inline-flex items-center gap-2 bg-primary/8 rounded-full px-4 py-2">
                  <i className="ri-check-line text-primary text-sm" />
                  <span className="font-body text-xs font-semibold text-primary">{party.highlight}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}